module.exports = __webpack_public_path__ + "img/logo44.a959101c.png";